import React, { useState,useEffect } from "react";
import { Modal, Button, Card, Box, Typography } from "@mui/material";
import pdfFile from '../../assets/pdf/NDA-drone.docx';
import pdfFile1 from '../../assets/pdf/MOU-drone.docx';
import HomeNavbar from "./Navbar";
import {Footer} from "../../shared";
import Img1 from '../../assets/image/png/Slide1.jpeg';
import Img2 from '../../assets/image/png/Slide2.jpeg';
import Img3 from '../../assets/image/png/Slide3.jpeg';
import Img4 from '../../assets/image/png/Slide4.jpeg';
import Img5 from '../../assets/image/png/Slide5.jpeg';
import Img6 from '../../assets/image/png/Slide6.jpeg';
import Img7 from '../../assets/image/png/Slide7.jpeg';
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight, FaDownload, FaFileAlt } from "react-icons/fa";
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import DynamicNDA from "./DynamicNDA";
import DynamicMOU from "./DynamicMOU";
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import NDAPDF from "./NDAPDF";
import MOUPDF from "./MOUPDF";

const UploadMou = () => {
  const [ndaAgreed, setNdaAgreed] = useState(false);
  const [mouAgreed, setMouAgreed] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [ndaFile, setNdaFile] = useState(null);
  const [mouFile, setMouFile] = useState(null);
  const [userId, setUserId] = useState('');
  // const [ndaAgreed, setNdaAgreed] = useState(false);  // NDA Agreement status
  // const [mouAgreed, setMouAgreed] = useState(false);  // MoU Agreement status
  // const [error, setError] = useState('');
  // const [success, setSuccess] = useState('');
  const [showNdaModal, setShowNdaModal] = useState(false);
  const [showMouModal, setShowMouModal] = useState(false);
  const [vendorData, setVendorData] = useState(null);
  const sliderRef = React.useRef(null);
  window.scrollTo({ top: 0, behavior: 'smooth' });
  const token = Cookies.get("token");
 
  useEffect(() => {
 
    const storedUserId = Cookies.get("userId");
 
    console.log(storedUserId);
    if (storedUserId) {
      setUserId(storedUserId);
    }
 
   
 
  }, []);

  useEffect(() =>{
    const storedVendorData = sessionStorage.getItem('vendorData');
    if(storedVendorData){
      setVendorData(JSON.parse(storedVendorData));
    }

    const storedUserId = Cookies.get('userId');
    if(storedUserId){
      setUserId(storedUserId);
    }
  }, []);
 
 
  // Handle form submission
  const handleSubmit = async (e) => {
  e.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!ndaAgreed || !mouAgreed) {
    setError('Please agree to both documents to proceed');
    toast.error('⚠️ Please agree to both documents');
    return;
  }

  const token = Cookies.get('token');
  const storedUserId = Cookies.get("userId");

  try {
    // Generate PDF blobs for both documents
    const [ndaBlob, mouBlob] = await Promise.all([
      pdf(<NDAPDF vendorData={vendorData}/>).toBlob(),
      pdf(<MOUPDF vendorData={vendorData}/>).toBlob()
    ]);

    // Create files from the blobs
    const ndaFile = new File([ndaBlob], `NDA_${vendorData?.modelNo || "Vendor"}.pdf`, {
      type: 'application/pdf'
    });

    const mouFile = new File([mouBlob], `MOU_${vendorData?.modelNo || "Vendor"}.pdf`, {
      type: 'application/pdf'
    });

    const ndaText = "I agree to the terms of the NDA";
    const mouText = "I agree to the terms of the MOU";

    const formData = new FormData();
    formData.append('NDA', ndaFile);
    formData.append('MOUU', mouFile);
    formData.append('ConsentNda', ndaAgreed ? ndaText : '');
    formData.append('ConsentMou', mouAgreed ? mouText : '');
    formData.append('userId', userId);

    const response = await axios.post(process.env.REACT_APP_API_URL + "/saveMou", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.data.status === 'success') {
      toast.success('Agreements submitted successfully!');
      setError('');
      setNdaAgreed(false);
      setMouAgreed(false);
    } else {
      toast.error('❌ Failed to save agreements');
      setSuccess('');
    }
  } catch (err) {
    console.error(err);
    toast.error('❌ Error: ' + (err.response?.data?.message || 'Server error'));
    setError(err.response?.data?.message || 'Failed to save agreements');
    setSuccess('');
  }
};
  const steps = [
    {
      image: Img1,
      title: 'Step 1: Review Documents',
      description: 'Carefully read through the NDA and MOU documents to understand the terms.',
    },
    {
      image: Img2,
      title: 'Step 2: Accept Agreements',
      description: 'Check the boxes to indicate your agreement with each document.',
    },
    {
      image: Img3,
      title: 'Step 3: Get Started',
      description: 'Once approved, you can start working with us.',
    },
    {
      image: Img4,
      title: 'Step 4: Collaborate',
      description: 'Work closely with our team to achieve your goals.',
    },
    {
      image: Img5,
      title: 'Step 5: Monitor Progress',
      description: 'Track the progress of your partnership in real-time.',
    },
    {
      image: Img6,
      title: 'Step 6: Finalize',
      description: 'Review and finalize the partnership details.',
    },
    {
      image: Img7,
      title: 'Step 7: Celebrate Success',
      description: 'Celebrate the successful collaboration.',
    },
  ];
 
  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  };
 
  return (
    <>
      <HomeNavbar />
     
      <Box sx={{
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        minHeight: '100vh',
        marginTop: '30px',
        py: 8,
        px: { xs: 2, sm: 4, md: 6 }
      }}>
        <Typography variant="h3" sx={{
          fontWeight: 700,
          color: '#2c3e50',
          textAlign: 'center',
          mb: 6,
          fontSize: { xs: '2rem', md: '2.5rem' }
        }}>
          Partnership Agreements
        </Typography>
 
        <Box sx={{
          maxWidth: '800px',
          mx: 'auto',
          mb: 8
        }}>
          {/* NDA Card */}
         {/* NDA Card */}
<Card sx={{
  mb: 4,
  borderRadius: 3,
  boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
  overflow: 'hidden',
  borderLeft: '5px solid #2ecc71' // Changed to green
}}>
  <Box sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    p: 4
  }}>
    <Box sx={{
      flex: 1,
      pr: { md: 3 }
    }}>
      <Typography variant="h5" sx={{
        fontWeight: 600,
        mb: 1,
        color: '#2c3e50',
        display: 'flex',
        alignItems: 'center'
      }}>
        <FaFileAlt style={{ marginRight: '10px', color: '#2ecc71' }} /> {/* Changed icon color */}
        Non-Disclosure Agreement (NDA)
      </Typography>
      <Typography variant="body1" sx={{
        color: '#7f8c8d',
        mb: 2
      }}>
        Please review and accept the NDA to proceed with our partnership.
      </Typography>
      <Box sx={{
        display: 'flex',
        gap: 2,
        mb: 2
      }}>
        <Button
          variant="outlined"
          startIcon={<FaFileAlt />}
          onClick={() => setShowNdaModal(true)}
          sx={{
            textTransform: 'none',
            borderRadius: 2
          }}
        >
          View Document
        </Button>
        {/* <Button
          variant="contained"
          startIcon={<FaDownload />}
          href={pdfFile}
          download
          sx={{
            textTransform: 'none',
            borderRadius: 2,
            bgcolor: '#2ecc71', // Changed button background
            '&:hover': { bgcolor: '#27ae60' } // Changed hover background
          }}
        >
          Download
        </Button> */}

        <PDFDownloadLink
         document={<NDAPDF vendorData={vendorData}/>}
         fileName={`NDA_${vendorData?.modelNo || "Vendor"}.pdf`}
         >
          {({ loading }) => (
            <Button
              variant="contained"
              startIcon={<FaDownload/>}
              disabled ={loading}
              sx={{
                textTransform: 'none',
                borderRadius: 2,
                bgcolor: '#2ecc71',
                '&hover': { bgcolor: '#27ae60' }
              }}
              >
                {loading ? "Loading Document..." : "Download PDF"}
              </Button>
          )}
         </PDFDownloadLink>
      </Box>
    </Box>
    <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pl: { md: 3 },
        borderLeft: { md: '1px solid #e0e0e0' }
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <input
            type="checkbox"
            id="nda-checkbox"
            checked={ndaAgreed}
            onChange={(e) => setNdaAgreed(e.target.checked)}
            style={{
              width: '20px',
              height: '20px',
              accentColor: '#2ecc71'
            }}
          />
          <Typography component="label" htmlFor="nda-checkbox" sx={{
            fontWeight: 500,
            cursor: 'pointer'
          }}>
            I agree to the terms of the NDA
          </Typography>
        </Box>
      </Box>
  </Box>
</Card>
 
 
          {/* MOU Card */}
          <Card sx={{
            mb: 4,
            borderRadius: 3,
            boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            borderLeft: '5px solid #2ecc71'
          }}>
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              p: 4
            }}>
              <Box sx={{
                flex: 1,
                pr: { md: 3 }
              }}>
                <Typography variant="h5" sx={{
                  fontWeight: 600,
                  mb: 1,
                  color: '#2c3e50',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <FaFileAlt style={{ marginRight: '10px', color: '#2ecc71' }} />
                  Memorandum of Understanding (MOU)
                </Typography>
                <Typography variant="body1" sx={{
                  color: '#7f8c8d',
                  mb: 2
                }}>
                  Please review and accept the MOU to finalize our partnership.
                </Typography>
                <Box sx={{
                  display: 'flex',
                  gap: 2,
                  mb: 2
                }}>
                  <Button
                    variant="outlined"
                    startIcon={<FaFileAlt />}
                    onClick={() => setShowMouModal(true)}
                    sx={{
                      textTransform: 'none',
                      borderRadius: 2
                    }}
                  >
                    View Document
                  </Button>
                  {/* <Button
                    variant="contained"
                    startIcon={<FaDownload />}
                    href={pdfFile1}
                    download
                    sx={{
                      textTransform: 'none',
                      borderRadius: 2,
                      bgcolor: '#2ecc71',
                      '&:hover': { bgcolor: '#27ae60' }
                    }}
                  >
                    Download
                  </Button> */}

                  <PDFDownloadLink
                    document={<MOUPDF vendorData={vendorData}/>}
                    fileName={`MOU_${vendorData?.modelNo || "Vendor"}.pdf`}
                    >
                      {({ loading }) => (
                        <Button
                          variant="contained"
                          startIcon={<FaDownload/>}
                          disabled ={loading}
                          sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            bgcolor: '#2ecc71',
                            '&hover': { bgcolor: '#27ae60' }
                          }}
                          >
                            {loading ? "Loading Document..." : "Download PDF"}
                          </Button>
                      )}
                    </PDFDownloadLink>
                </Box>
              </Box>
              <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pl: { md: 3 },
        borderLeft: { md: '1px solid #e0e0e0' }
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <input
            type="checkbox"
            id="mou-checkbox"
            checked={mouAgreed}
            onChange={(e) => setMouAgreed(e.target.checked)}
            style={{
              width: '20px',
              height: '20px',
              accentColor: '#2ecc71'
            }}
          />
          <Typography component="label" htmlFor="mou-checkbox" sx={{
            fontWeight: 500,
            cursor: 'pointer'
          }}>
            I agree to the terms of the MOU
          </Typography>
        </Box>
      </Box>
            </Box>
          </Card>
 
          {/* Submit Button */}
<Box sx={{
  display: 'flex',
  justifyContent: 'center',
  mt: 4
}}>
  <Button
    variant="contained"
    color="primary"
    onClick={handleSubmit}
    sx={{
      bgcolor: '#2ecc71',
      '&:hover': { bgcolor: '#27ae60' },
      px: 4,
      py: 2,
      fontSize: '1.1rem'
    }}
  >
    Submit Agreements
  </Button>
</Box>
 
{error && (
  <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
    {error}
  </Typography>
)}
 
{success && (
  <Typography color="success" sx={{ mt: 2, textAlign: 'center' }}>
    {success}
  </Typography>
)}
        </Box>
 
        {/* How it Works Section */}
        <Box sx={{ textAlign: 'center', mt: 8, mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: '700',
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              mb: 6,
              color: '#328CCD',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            How It Works
          </Typography>
 
          {/* Slider Component */}
          <Box sx={{ position: 'relative', maxWidth: '1200px', mx: 'auto' }}>
            <Slider ref={sliderRef} {...sliderSettings}>
              {steps.map((step, index) => (
                <Box key={index}>
                  <Box
                    component="img"
                    src={step.image}
                    alt={step.title}
                    sx={{
                      width: '100%',
                      height: { xs: '300px', sm: '400px', md: '500px' },
                      objectFit: 'contain',
                      borderRadius: '12px',
                      boxShadow: 3,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: { xs: '10px', sm: '20px', md: '30px' },
                      left: { xs: '10px', sm: '20px', md: '30px' },
                      color: 'white',
                      textAlign: 'left',
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      padding: { xs: '8px', sm: '16px', md: '24px' },
                      borderRadius: '8px',
                      maxWidth: { xs: '90%', sm: '80%', md: '60%' },
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: '700',
                        fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                        mb: 1,
                      }}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem', md: '1.125rem' },
                        lineHeight: '1.6',
                      }}
                    >
                      {step.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Slider>
 
            {/* Custom left and right arrows */}
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                px: { xs: 1, sm: 2, md: 4 },
                transform: 'translateY(-50%)',
              }}
            >
              <Button
                onClick={() => sliderRef.current.slickPrev()}
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: '50%',
                  minWidth: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  },
                }}
              >
                <FaArrowLeft size={24} />
              </Button>
              <Button
                onClick={() => sliderRef.current.slickNext()}
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: '50%',
                  minWidth: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  },
                }}
              >
                <FaArrowRight size={24} />
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
 
      {/* NDA Modal */}
      <Modal open={showNdaModal} onClose={() => setShowNdaModal(false)} maxWidth="lg" fullWidth>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Box sx={{
      p: 3,
      borderBottom: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      bgcolor: '#3498db',
      color: 'white'
    }}>
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        <FaFileAlt style={{ marginRight: '10px' }} />
        Non-Disclosure Agreement (NDA)
      </Typography>
      <Button onClick={() => setShowNdaModal(false)} sx={{ color: 'white' }}>
        ×
      </Button>
    </Box>
    <Box sx={{
      p: 3,
      overflowY: 'auto',
      flex: 1
    }}>
      <DynamicNDA vendorData={vendorData}/>

      {/* <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
        <p><strong>NON-DISCLOSURE AGREEMENT (NDA)</strong></p>
        <p>This Non-Disclosure Agreement ("Agreement") is made and entered into on this <u>20th</u> day of <u>January</u> 2025, by and between:</p>
        <p><strong>Drone Planet</strong>, a Startup Stairs Pvt. Ltd company registered under the laws of India, with its registered office at Plot No 251, Udyog Vihar, Phase IV, Gurgaon–122015 (hereinafter referred to as "Marketplace" or "First Party")</p>
        <p>AND</p>
        <p><strong>[Vendor Name]</strong>, a business entity registered under the laws of India, with its registered office at [Vendor Address] (hereinafter referred to as "[Vendor Name]").</p>
        <p>(Collectively, referred to as the "Parties" and individually as a "Party").</p>
 
        <p><strong>1. Purpose</strong></p>
        <p>The Parties wish to explore and engage in a business relationship wherein the Vendor will sell products (specifically drones and spare parts), through the Marketplace's platform. In course of this business relationship, the Parties may disclose certain confidential and proprietary information. This Agreement sets forth the terms and conditions under which such information will be disclosed and protected.</p>
 
        <p><strong>2. Definition of Confidential Information</strong></p>
        <p>"Confidential Information" includes, but is not limited to:</p>
        <p>a. Business plans, strategies, customer lists, vendor lists, financial information, marketing techniques, technical data, product information, specifications, and designs.</p>
        <p>b. Information related to the Marketplace’s technology, platform, website, software, intellectual property, and business operations.</p>
        <p>c. Any proprietary or sensitive data exchanged between the Parties, including customer information and order data.</p>
        <p>d. Information that is identified as confidential at the time of disclosure, either orally or in writing, or that by its nature should reasonably be understood to be confidential.</p>
 
        <p><strong>3. Exclusions from Confidential Information</strong></p>
        <p>Confidential Information does not include information that:</p>
        <p>a. Is or becomes publicly available without breach of this Agreement by the Receiving Party.</p>
        <p>b. Is received from a third party who is not under any obligation of confidentiality.</p>
        <p>c. Was already in the receiving Party’s possession before disclosure by the disclosing Party.</p>
        <p>d. Is independently developed by the receiving Party without use of or reference to the Confidential Information.</p>
        <p>e. Is required to be disclosed by law, court order, or governmental regulation, provided that the receiving Party gives prompt written notice of such requirement and cooperates with the disclosing Party to seek a protective order or other appropriate remedy.</p>
 
        <p><strong>4. Obligations of the Parties</strong></p>
        <p>a. Non-Disclosure: The Receiving Party agrees not to disclose the Confidential Information to any third party without the prior written consent of the disclosing Party, except as required for the purpose of this business relationship.</p>
        <p>b. Non-Use: The Receiving Party agrees not to use the Confidential Information for any purpose other than the purpose set forth in this Agreement.</p>
        <p>c. Protection: The Receiving Party shall take reasonable measures to protect the Confidential Information and prevent unauthorized use, dissemination, or disclosure.</p>
        <p>d. Return or Destruction: Upon termination of this Agreement or upon the disclosing Party’s request, the Receiving Party agrees to promptly return or destroy all materials containing Confidential Information.</p>
 
        <p><strong>5. Permitted Disclosures</strong></p>
        <p>The Receiving Party may disclose Confidential Information to its employees, contractors, or agents on a need-to-know basis, provided that such individuals are bound by confidentiality obligations no less stringent than those contained in this Agreement.</p>
 
        <p><strong>6. Duration of Confidentiality Obligations</strong></p>
        <p>a. The obligations of confidentiality shall remain in effect during the term of the business relationship between the Parties and for a period of two [2] years after the termination of this Agreement.</p>
        <p>b. Trade secrets shall remain protected indefinitely or for as long as applicable law allows.</p>
 
        <p><strong>7. Intellectual Property</strong></p>
        <p>a. All intellectual property, including trademarks, trade names, logos, patents, and proprietary information, remains the property of the disclosing Party. The Receiving Party shall not acquire any rights or licenses in any intellectual property as a result of this Agreement.</p>
        <p>b. Any intellectual property, work product, or inventions developed during the course of the business relationship shall remain the property of the respective Party unless otherwise agreed in writing.</p>
 
        <p><strong>8. No Obligation to Enter into Transaction</strong></p>
        <p>This Agreement does not obligate either Party to enter into any further business transactions or contracts. The disclosure of Confidential Information does not create any agency, partnership, or joint venture relationship between the Parties.</p>
 
        <p><strong>9. Remedies</strong></p>
        <p>In the event of a breach of this Agreement, the disclosing Party shall be entitled to seek injunctive relief, specific performance, or any other equitable remedies available by law. The disclosing Party may also pursue monetary damages resulting from the breach.</p>
 
        <p><strong>10. Governing Law</strong></p>
        <p>This Agreement shall be governed by and construed in accordance with the laws of India.</p>
 
        <p><strong>11. Dispute Resolution</strong></p>
        <p>In the event of any dispute arising from this Agreement, the Parties agree to resolve the matter through good faith negotiations. If the dispute cannot be resolved amicably, it shall be referred to arbitration in accordance with Indian law.</p>
 
        <p><strong>12. Term and Termination</strong></p>
        <p>a. This Agreement shall remain in effect until terminated by either Party with [30] days' written notice.</p>
        <p>b. Termination of this Agreement does not relieve either Party of its obligations regarding Confidential Information disclosed prior to termination.</p>
 
        <p><strong>13. Miscellaneous</strong></p>
        <p>a. Amendments: Any amendments or modifications to this Agreement must be made in writing and signed by both Parties.</p>
        <p>b. No Waiver: The failure of either Party to enforce any provision of this Agreement shall not be construed as a waiver of that provision or any other provision.</p>
        <p>c. Entire Agreement: This Agreement constitutes the entire understanding between the Parties with respect to the subject matter hereof and supersedes all prior agreements, negotiations, and discussions.</p>
 
        <p><strong>14. Signatures</strong></p>
        <p>IN WITNESS WHEREOF, the Parties have executed this Non-Disclosure Agreement as of the date first written above.</p>
 
        <p>For DronePlanet (Product of Startup Stairs Pvt. Ltd.)</p>
        <p>________________________________________<br />
        Name: <br />
        Title: <br />
        Date: </p>
 
        <p>For [Vendor Name]</p>
        <p>________________________________________<br />
        Name: <br />
        Title: <br />
        Date: </p>
      </Typography> */}
    </Box>
    <Box sx={{
      p: 2,
      borderTop: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'flex-end'
    }}>
      <Button
        variant="contained"
        onClick={() => setShowNdaModal(false)}
        sx={{
          bgcolor: '#3498db',
          '&:hover': { bgcolor: '#2980b9' }
        }}
      >
        Close
      </Button>
    </Box>
  </Box>
</Modal>
 
 
      {/* MOU Modal */}
      <Modal open={showMouModal} onClose={() => setShowMouModal(false)} maxWidth="lg" fullWidth>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Box sx={{
      p: 3,
      borderBottom: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      bgcolor: '#2ecc71',
      color: 'white'
    }}>
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        <FaFileAlt style={{ marginRight: '10px' }} />
        Memorandum of Understanding (MoU)
      </Typography>
      <Button onClick={() => setShowMouModal(false)} sx={{ color: 'white' }}>
        ×
      </Button>
    </Box>
    <Box sx={{ p: 3, overflowY: 'auto', flex: 1 }}>
      <DynamicMOU vendorData={vendorData}/>
      {/* <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
        <p><strong>MEMORANDUM OF UNDERSTANDING</strong></p>
        <p>This Memorandum of Understanding ("MoU") is entered into on this __ day of __________ 2024:</p>
        <p><strong>BY AND BETWEEN</strong></p>
        <p><strong>Drone Planet</strong>, a Startup Stairs Pvt. Ltd., a company registered under the laws of India, with its registered office at Plot 251, Phase IV, Udyog Vihar, Gurugram (hereinafter referred to as "Marketplace" or "First Party")</p>
        <p>AND</p>
        <p><strong>[Vendor Name]</strong>, a business entity registered under the laws of [Country/State], with its registered office at [Vendor Address] (hereinafter referred to as "Vendor" or "Second Party")</p>
        <p>Both the First Party and Second Party are herein collectively referred to as the "Parties" and individually as a "Party".</p>
 
        <p><strong>1. PURPOSE</strong></p>
        <p>The purpose of this MoU is to establish the terms and conditions under which the Vendor shall sell drones and spare parts on the Marketplace, while the Marketplace shall facilitate the sale of these products through its platform.</p>
 
        <p><strong>2. DURATION OF THE MOU</strong></p>
        <p>This MoU shall become effective as of the date above and shall continue for [Specify Duration] year(s), unless terminated earlier by either party with thirty (30) days' written notice.</p>
 
        <p><strong>3. SCOPE OF THE AGREEMENT</strong></p>
        <p>a. Products: Sale of drones and spare parts. <br />b. Vendor: Compliance with Indian laws, certifications, approvals. <br />c. Marketplace: Provide platform access, marketing, and support.</p>
 
        <p><strong>4. COMMISSION RATES</strong></p>
        <p>a. Drones: 10% commission <br />b. Spare parts: 15% commission <br />c. Payout: Within 15 business days post-sale <br />d. Monthly processing <br />e. Dashboard access for transparency</p>
 
        <p><strong>5. VENDOR OBLIGATIONS</strong></p>
        <p>Accurate listings, legal compliance, timely dispatch, after-sales service, and adequate stock maintenance.</p>
 
        <p><strong>6. MARKETPLACE OBLIGATIONS</strong></p>
        <p>Platform listing, promotional support, customer service, and product approval rights.</p>
 
        <p><strong>7. PRODUCT LISTINGS AND PRICING</strong></p>
        <p>Vendor controls pricing, Marketplace may run promotions with prior notice of changes required.</p>
 
        <p><strong>8. RETURNS AND REFUNDS</strong></p>
        <p>Vendor adheres to return policy, bears return costs unless otherwise agreed in writing.</p>
 
        <p><strong>9. DELIVERY TERMS</strong></p>
        <p>Vendor responsible for packaging, shipping, tracking, delivery updates, and refund obligations.</p>
 
        <p><strong>10. TERMINATION</strong></p>
        <p>30-day notice for termination. Immediate termination for breach or unlawful activity.</p>
 
        <p><strong>11. CONFIDENTIALITY</strong></p>
        <p>Confidential info includes financials, specs, and customer data. Survives 2 years post-termination.</p>
 
        <p><strong>12. DISPUTE RESOLUTION</strong></p>
        <p>Negotiation, then arbitration under the Indian Arbitration Act. Venue: New Delhi. Language: English.</p>
 
        <p><strong>13. GOVERNING LAW</strong></p>
        <p>Governing Law: India</p>
 
        <p><strong>14. MISCELLANEOUS</strong></p>
        <p>a. Written amendments only. <br />b. Entire agreement. <br />c. No joint venture or partnership.</p>
 
        <p><strong>15. SIGNATURES</strong></p>
        <p>IN WITNESS WHEREOF, the Parties have executed this MoU on the date mentioned above.</p>
        <p><strong>For Startup Stairs Pvt. Ltd.</strong></p>
        <p>Name: ____________________ <br />Title: ____________________ <br />Date: ____________________</p>
 
        <p><strong>For [Vendor Name]</strong></p>
        <p>Name: ____________________ <br />Title: ____________________ <br />Date: ____________________</p>
 
        <hr />
        <p><strong>📎 LIST OF REQUIRED DOCUMENTS FOR VENDOR ONBOARDING</strong></p>
        <p><strong>1. Business Registration Documents</strong></p>
        <p>- Certificate of Incorporation / Business License<br />- Partnership Deed (if applicable)<br />- GST/VAT/TIN registration<br />- MSME Certificate (if applicable)<br />- PAN Card</p>
 
        <p><strong>2. Banking and Financial Information</strong></p>
        <p>- Bank Account details with canceled cheque<br />- Tax Identification Number<br />- Financial Statements (if required)</p>
 
        <p><strong>3. Compliance & Regulatory</strong></p>
        <p>- Required licenses/permits<br />- Data Protection agreements (if applicable)</p>
 
        <p><strong>4. Contracts</strong></p>
        <p>- Vendor Agreement<br />- NDA</p>
 
        <p><strong>5. Product Documentation</strong></p>
        <p>- Product listings and certifications</p>
 
        <p><strong>6. References (optional)</strong></p>
        <p>- Client references / testimonials</p>
 
        <p><strong>7. Tax Compliance Certificates</strong></p>
        <p>- Tax Residency Certificate<br />- Tax Clearance Certificate</p>
      </Typography> */}
    </Box>
    <Box sx={{
      p: 2,
      borderTop: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'flex-end'
    }}>
      <Button
        variant="contained"
        onClick={() => setShowMouModal(false)}
        sx={{
          bgcolor: '#2ecc71',
          '&:hover': { bgcolor: '#27ae60' }
        }}
      >
        Close
      </Button>
    </Box>
  </Box>
</Modal>
 
 
      <Footer />
    </>
  );
};
 
export default UploadMou;